
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.715 28.953a.977.977 0 010 1.381l-1.381 1.381a.977.977 0 01-1.381 0l-9.668-9.668a.954.954 0 01-.222-.361A11.925 11.925 0 0112 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12c0 2.645-.865 5.08-2.314 7.063a.942.942 0 01.361.222l9.668 9.668zM12 4a8 8 0 100 16 8 8 0 000-16z"}})])
          )
        }
      }
    